export default __webpack_public_path__ + "static/media/holmasto-logo-white.aabc03d1.svg";